type LoginApp = 'farm' | 'supplier' | 'market';

const normalizeLoginResponse = (
  response: ILoginResponse,
  app: LoginApp,
): IUser | null => {
  const {farmer_profile, supplier_profile, market_profile} = response;

  switch (app) {
    case 'farm': {
      if (!farmer_profile) return null;

      return {
        message: response.message,
        is_registered: response.is_registered,
        token: response.token,
        profile: {
          guid: farmer_profile.guid,
          name: farmer_profile.name,
          account_type: farmer_profile.account_type[0] ?? null,
          username: farmer_profile.username,
          credit: farmer_profile.credit,
          phone_number: farmer_profile.cell_phone,
          state: farmer_profile.user_state,
          city: farmer_profile.user_city,
          user_state: farmer_profile.user_state,
          user_city: farmer_profile.user_city,
          profile_image: farmer_profile.profile_image,
          latlong: farmer_profile.latlong.map(String) as [string, string],
        },
      };
    }

    case 'supplier': {
      if (!supplier_profile) return null;

      return {
        message: response.message,
        is_registered: response.is_registered,
        token: response.token,
        profile: {
          guid: supplier_profile.guid,
          name: supplier_profile.name,
          account_type: supplier_profile.account_type?.[0] ?? null,
          username: supplier_profile.username,
          credit: supplier_profile.credit,
          phone_number: supplier_profile.phone_number,
          state: supplier_profile.state,
          city: supplier_profile.city,
          profile_image: supplier_profile.profile_image,
          latlong: supplier_profile.latlong.map(String) as [string, string],
          ...(supplier_profile.store && {
            store: {
              guid: supplier_profile.store.guid,
              title: supplier_profile.store.title,
              store_status: supplier_profile.store
                .store_status as IStore['store_status'],
              store_type: supplier_profile.store.store_type as IStoreType,
              logo: supplier_profile.store.logo,
            },
          }),
        },
      };
    }

    case 'market': {
      if (!market_profile) return null;

      return {
        message: response.message,
        is_registered: response.is_registered,
        token: response.token,
        profile: {
          guid: market_profile.guid,
          name: market_profile.name,
          account_type: market_profile.account_type,
          username: market_profile.username,
          credit: 0,
          phone_number: market_profile.phone_number,
          state: market_profile.state,
          city: market_profile.city,
          profile_image: market_profile.profile_image,
          latlong: market_profile.latlong.map(String) as [string, string],
        },
      };
    }

    default:
      return null;
  }
};

export default normalizeLoginResponse;
